import {Fragment, useState} from 'react'
import Axios from 'axios'
import { useTranslation } from "react-i18next"
import Swal from 'sweetalert2'
import { Container, Row, Col, Button, Form} from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function Forgot() {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)
    
    const handleSubmit = async (e) => {
        e.preventDefault()
        const clientEmail = e.target.email.value
        setIsLoading(true)
        await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/forgot/sendmail', {email: clientEmail})
            .then((res) => {
                setIsLoading(false)
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'success',
                    text: t('forgot.viewemail'),
                    target: document.getElementById('root')
                })
            }).catch((err) => {
                setIsLoading(false)
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'error',
                    text: t('forgot.error')
                })
            })
    }
    return (
        <Fragment>
            <header className="cabecera d-flex align-items-center px-4">
                <Link to='/'><img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" height={28} /></Link>
            </header>
            <Container fluid className='p-0 m-0'>
                <Row className='p-0 m-0 centro-auth'>
                    <Col md={7} className='d-none d-md-flex align-items-center justify-content-center aside-auth' style={{
                        background: 'linear-gradient(135deg, #0B0C0E 0%, #1A1B1E 100%)',
                    }}>
                        <div style={{maxWidth: 420, color: 'white', padding: 40}}>
                            <h1 style={{color: 'white', fontSize: 40, marginBottom: 16}}>{t('forgot.question')}</h1>
                            <p style={{fontSize: 16, opacity: 0.7, lineHeight: 1.6}}>{t('forgot.help')}</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} className='d-flex align-items-center p-5'>
                        <Container className='login-form-container'>
                            <div className='login-brand'>
                                <img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" />
                            </div>
                            <h1 className='login-title'>{t('forgot.question')}</h1>
                            <p className='login-subtitle'>{t('forgot.help')}</p>
                            <Form className="formulario" onSubmit={handleSubmit}>
                                <Row className="mb-4">
                                    <Col>
                                        <Form.Label htmlFor='email'>{t('forgot.email')}</Form.Label>
                                        <Form.Control name="email" type="email" autoComplete="off" />
                                    </Col>
                                </Row>
                                <Row className="mt-5">
                                    <Col>
                                        <Button variant='primary' type="submit" className="w-100">
                                            {isLoading
                                                ? <span className="spinner-border spinner-border-sm align-middle"></span>
                                                : <>{t('forgot.submit')}</>
                                            }
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='text-center pt-4'>
                                        <span style={{fontSize:13, color:'var(--text-secondary)'}}>{t('forgot.rememberpassword')}</span><br/>
                                        <Link to={`/${t("url.auth.login")}`} className='btn btn-default w-100 mt-2'>
                                            {t('signin.login')}
                                        </Link>
                                    </Col>
                                </Row>
                            </Form>
                        </Container>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}